export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN',
  ONION: 'ONION'
};

export const DEFAULT_LIMIT = 100;
export const DEFAULT_LIMIT_OPTIONS = [5, 10, 25, 100];

export const DEFAULT_ORDER_BY = 'asc';

export const RATINGS = [
  {
    id: 1,
    name: 'Bad'
  },
  {
    id: 2,
    name: 'Not good enough'
  },
  {
    id: 3,
    name: 'All right'
  },
  {
    id: 4,
    name: 'Good'
  },
  {
    id: 5,
    name: 'Great'
  },
  {
    id: 6,
    name: 'Does not apply'
  }
];

export const SIDES = [
  {
    id: 1,
    name: 'Too little'
  },
  {
    id: 2,
    name: 'Fit'
  },
  {
    id: 3,
    name: 'Too much'
  },
  {
    id: 4,
    name: 'See comments'
  }
];

// Branch types, mirroring branch_types.id
export const BRANCH_TYPE_PRESCHOOL = 2;
